import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate, useLocation } from "react-router-dom";
import bymoLogo from "./go1/img/bymowhite.png";
import infoLogo from "./img/information.png";
import ordersLogo from "./img/orders.png";
import onboardingLogo from "./img/onboarding.png";
import statsLogo from "./img/stats.png";
import orderLogo from "./img/order.png";
import stockLogo from "./img/stock.png";
import fulfillmentLogo from "./img/fullfilment.png";


import './go1/SideApp.css';
import './App.css';
import './stats1/stats.css';

// Component Imports
import Login from "./Login";
import Overview from "./Overview";
import AdminLogin from "./AdminLogin";
import AdminPage from "./AdminPage";
import AdminOrders from "./AdminOrders";
import UserInfo from "./go1/UserInfo";
import UserActivity from "./go1/UserActivity";
import Orders from "./go1/Orders";
import Rules from "./go1/Rules";
import Import from "./go2/Import";
import PublicForm from "./onboarding/public/PublicForm";
import AdminOnboarding from "./onboarding/admin/AdminOnboarding";
import CodesPerf from "./stats1/codesPerf";
import CollectionsStats from "./stats1/collectionStats";
import CheckStock from "./inventory/checkStock";
import Fulfillment from './fulfillment/Fulfillment';
import AIMain from './AI/aimain';

const TRACKING_ID = "G-8S8P00T1SP"; // Replace with your actual Google Analytics tracking ID

// Analytics component for initializing and tracking route changes
const Analytics = () => {
    const location = useLocation();

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
        script.async = true;
        document.head.appendChild(script);

        // Initialize Google Analytics
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", TRACKING_ID);
    }, []);

    useEffect(() => {
        if (window.gtag) {
            window.gtag("config", TRACKING_ID, { page_path: location.pathname });
        }
    }, [location]);

    return null;
};

const App = () => {
    const location = useLocation();
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(() => {
        return sessionStorage.getItem("isUserLoggedIn") === "true";
    });
    const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(() => {
        return sessionStorage.getItem("isAdminLoggedIn") === "true";
    });

    useEffect(() => {
        if (isUserLoggedIn) {
            sessionStorage.setItem("isUserLoggedIn", "true");
        } else {
            sessionStorage.removeItem("isUserLoggedIn");
        }

        if (isAdminLoggedIn) {
            sessionStorage.setItem("isAdminLoggedIn", "true");
        } else {
            sessionStorage.removeItem("isAdminLoggedIn");
        }
    }, [isUserLoggedIn, isAdminLoggedIn]);

    // Define paths for menus
    const noMenuPaths = ["/", "/admin-login", "/public-form"];
    const isMenuVisible = !noMenuPaths.includes(location.pathname);

    const handleLogout = () => {
        setIsUserLoggedIn(false);
        setIsAdminLoggedIn(false);
        sessionStorage.clear();
    };

    return (
        <div>
            <Analytics />
            <div className={`side-app-container ${isMenuVisible ? "" : "no-menu-container"}`}>
                {isMenuVisible && isAdminLoggedIn && (
                    <aside className="sticky-menu">
                        <div className="logo-container">
                            <img src={bymoLogo} alt="BYMO Logo" className="bymo-logo-menu" />
                        </div>
                        
                        <nav className="menu-links">
                            

                            <NavLink to="/user-info" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={infoLogo} alt="Info Icon" className="menu-icon" /> Information
                            </NavLink>

                            <NavLink to="/side-orders" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={ordersLogo} alt="Orders Icon" className="menu-icon" /> Orders
                            </NavLink>

                            <NavLink to="/admin-onboarding" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={onboardingLogo} alt="Onboarding Icon" className="menu-icon" /> Onboarding
                            </NavLink>

                            {/* Divider Line */}
                            <div className="menu-divider">________</div>

                            <NavLink to="/stats1" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={statsLogo} alt="Stats Icon" className="menu-icon" /> Stats
                            </NavLink>
                            <NavLink to="/collectionStats" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={orderLogo} alt="Order Icon" className="menu-icon" /> Collections
                            </NavLink>

                            <NavLink to="/check-stock" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={stockLogo} alt="Stock Icon" className="menu-icon" /> Stock
                            </NavLink>
                            <NavLink to="/fulfillment" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={fulfillmentLogo} alt="Fulfillment Icon" className="menu-icon" /> Fulfillment
                            </NavLink>
                            
                            <NavLink to="/ai" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                                <img src={stockLogo} alt="AI Icon" className="menu-icon" /> AI
                            </NavLink>
                           
                        </nav>
                        <button onClick={handleLogout} className="menu-link-logout-button-side-menu">Logout</button>

                    </aside>
                )}
                <main
                    className={`content-container ${
                        isMenuVisible && location.pathname !== "/overview" ? "with-menu" : "no-menu"
                    }`}
                >
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/" element={<Login onLogin={() => setIsUserLoggedIn(true)} />} />
                        <Route path="/admin-login" element={<AdminLogin onLogin={() => setIsAdminLoggedIn(true)} />} />
                        <Route path="/public-form" element={<PublicForm />} />

                        {/* User-Only Routes */}
                        <Route path="/overview" element={isUserLoggedIn ? <Overview /> : <Navigate to="/" />} />
                        {/* Admin-Only Routes */}
                        <Route path="/admin" element={isAdminLoggedIn ? <AdminPage /> : <Navigate to="/admin-login" />} />
                        <Route path="/admin-orders" element={isAdminLoggedIn ? <AdminOrders /> : <Navigate to="/admin-login" />} />
                        <Route path="/user-info" element={isAdminLoggedIn ? <UserInfo /> : <Navigate to="/admin-login" />} />
                        <Route path="/side-user-activity" element={isAdminLoggedIn ? <UserActivity /> : <Navigate to="/admin-login" />} />
                        <Route path="/side-orders" element={isAdminLoggedIn ? <Orders /> : <Navigate to="/admin-login" />} />
                        <Route path="/side-rules" element={isAdminLoggedIn ? <Rules /> : <Navigate to="/admin-login" />} />
                        <Route path="/import" element={isAdminLoggedIn ? <Import /> : <Navigate to="/admin-login" />} />
                        <Route path="/admin-onboarding" element={isAdminLoggedIn ? <AdminOnboarding /> : <Navigate to="/admin-login" />} />
                        <Route path="/stats1" element={isAdminLoggedIn ? <CodesPerf /> : <Navigate to="/admin-login" />} />
                        <Route path="/collectionStats" element={isAdminLoggedIn ? <CollectionsStats /> : <Navigate to="/admin-login" />} />
                        <Route path="/check-stock" element={isAdminLoggedIn ? <CheckStock /> : <Navigate to="/admin-login" />} />
                        <Route path="/fulfillment" element={isAdminLoggedIn ? <Fulfillment /> : <Navigate to="/admin-login" />} />
                        <Route path="/ai" element={isAdminLoggedIn ? <AIMain /> : <Navigate to="/admin-login" />} />


                    </Routes>
                </main>
            </div>
        </div>
    );
};

export default App;
